import { type AudioLevelParser } from './audioLevels';

const MINIMUM_VOLUME = 0.01;

/**
 * Receive the latest audio level of a participant.
 *
 * The Vonage event is dispatched periodically up to 60 Hz by a Subscriber or Publisher.
 * @see https://tokbox.com/developer/sdks/js/reference/AudioLevelUpdatedEvent.html
 *
 * @param movingAvg - the previous average audio level, from 0 to 1.
 * @see https://developer.vonage.com/en/video/guides/ui-customization/general-customization#adjusting-user-interface-based-on-audio-levels
 * @param currentLevel - the current reported audio level, from 0 to 1.
 * @returns audio level with moving average applied, from 0 to 1.
 */
export const exponentiallyWeightedAudioLevel: AudioLevelParser = (
  movingAvg,
  currentLevel,
) => {
  if (currentLevel < MINIMUM_VOLUME) {
    return 0; // too quiet (silence or breathing), calculations are not required
  }

  if (movingAvg === 0 || movingAvg <= currentLevel) {
    return currentLevel;
  } else {
    const weightedPreviousValue = 0.7 * movingAvg;
    const weightedCurrentValue = 0.3 * currentLevel;

    return weightedPreviousValue + weightedCurrentValue;
  }
};
